module.exports = {"210422100":"新宾镇","210422101":"旺清门镇","210422102":"永陵镇","210422103":"平顶山镇","210422104":"大四平镇","210422105":"苇子峪镇","210422106":"木奇镇","210422108":"上夹河镇","210422109":"南杂木镇","210422202":"红升乡","210422203":"响水河子乡","210422204":"红庙子乡","210422205":"北四平乡","210422207":"榆树乡","210422208":"下夹河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210422.json
// module id = 537
// module chunks = 0